class Navigation {
    constructor() {
        this.button     = document.querySelector('.js-nav-button');
        this.navigation = document.querySelector('.js-navigation');
        this.body       = document.body;

        if (!this.button || !this.navigation) return;

        this.isOpen = false;

        this.mobileBreakpoint = 45 * 16; // 45rem in px (rem=16px)

        this.init();
    }

    init() {
        // Button toggelt Navigation
        this.button.addEventListener('click', () => this.toggle());

        // ESC schließt Navigation
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) this.close();
        });

        // Resize Listener
        window.addEventListener('resize', this.handleResize.bind(this));
    }

    handleResize() {
        // Wenn die Navigation offen ist und wir über mobilen Breakpoint gehen → schließen
        if (this.isOpen && window.innerWidth >= this.mobileBreakpoint) {
            this.close();
        }
    }

    open() {
        this.isOpen = true;
        this.body.classList.add('nav-open');
        this.navigation.classList.add('is-open');
        this.button.classList.add('is-active');
        this.button.blur();
    }

    close() {
        this.isOpen = false;
        this.body.classList.remove('nav-open');
        this.navigation.classList.remove('is-open');
        this.button.classList.remove('is-active');
        this.button.blur();
    }

    toggle() {
        this.isOpen ? this.close() : this.open();
    }
}

export default Navigation;
